import {openConfirmDialog} from 'platform/components';

import {isNil} from 'ramda';

import {useLazyGetActiveBusinessCaseByCustomerQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {shouldWarnBeforeCustomerEdit} from './shouldWarnBeforeCustomerEdit';

export const useWarnBeforeCustomerEdit = () => {
  const [getActiveBusinessCasesByCustomer] = useLazyGetActiveBusinessCaseByCustomerQuery();

  return async (customerId: string, onEdit: () => void) => {
    const activeBusinessCases = await getActiveBusinessCasesByCustomer({customerId})
      .unwrap()
      .catch(() => undefined);

    if (isNil(activeBusinessCases)) {
      onEdit();
      return;
    }

    if (shouldWarnBeforeCustomerEdit(activeBusinessCases)) {
      openConfirmDialog({
        text: i18n.t('entity.customer.warnings.activeBusinessCaseEdit'),
        onConfirm: onEdit,
        'data-testid': testIds.customer.detail('activeBusinessCaseEditWarning'),
      });
      return;
    }

    onEdit();
  };
};
